/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../../config/config"
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import axios from "axios";

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import DashboardSection from '../../DashboardContainer/DashboardSection';
import DomainTile from '../../DomainTile/DomainTile';
import ReusableTable from '../../ReusableTable/ReusableTable';
import styles from './RecordToReportJLRPage.module.css';

const WeekOptions = [
  { value: 'undefined', label: 'Select' },
  { value: 'All', label: '-All-' },
  ...Array.from({ length: 52 }, (_, i) => ({
    value: `W${i + 1}`,
    label: `Week ${i + 1}`
  }))
];

const { API_BASE_URL } = config;

const TimeLinessJLR = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    monthData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [entity, setEntity] = useState(null);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState([]);

  const [week, setWeek] = useState(WeekOptions[0]);

  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [timelinessTaskPage, setTimelinessTaskPage] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const itemsPerPage = 100;
  const [selectedPage, setSelectedPage] = useState(1);

  const history = useHistory()

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters(prev => ({ ...prev, monthData: updatedMonths }));
  };

  const handleWeekChange = (selected) => {
    setWeek(selected);
    setFilters(prev => ({ ...prev, weekData: selected }));
  };

  const handleTimelinessTaskPageChange = (page) => {
    setTimelinessTaskPage(page);
    fetchJLRTimelinessDrilldownData(page);
  };

  const handleApply = () => {

    const entityFilterData = entity?.value || "";
    const yearFilterData = year?.value || "";

    if (entityFilterData === "") {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    if (yearFilterData === "") {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    setTimelinessTaskPage(1);
    fetchJLRTimelinessDrilldownData(1);
  }

  const fetchJLRTimelinessDrilldownData = async (page = timelinessTaskPage) => {
    setdataLoading(true);
    try {
      const entityFilterData = entity?.value || '';
      const yearFilterData = year?.value || '';
      const monthFilterData = month?.map(m => m?.value) || [];

      const limit = itemsPerPage;
      const offset = (page - 1) * limit;

      const response = await axios.post(`${API_BASE_URL}/api/timelinesstask-drilldown`,
        {
          entity: entityFilterData,
          year: yearFilterData,
          month: monthFilterData,
          limit: limit,
          offset: offset,
        },
        {
          headers: {
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
      );

      setData(response.data.data);
      setTotalRecords(response.data.total);
    } catch (error) {
      console.error('Error fetching JLR Timeliness of Tasks Drilldown data:', error);
    } finally {
      setdataLoading(false);
    }
  };

  // const handleCSVDownload = () => {
  //   const csvHeader = columns.map(col => col.header).join(',');
  //   const csvRows = data.map(row =>
  //     columns.map(col => `"${(row[col.accessor] || '').replace(/"/g, '""')}"`).join(',')
  //   );
  //   const csvContent = [csvHeader, ...csvRows].join('\n');
  //   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(blob);
  //   link.download = 'Timeliness_of_Task.csv';
  //   link.click();
  // };

  const handleCSVDownload = async () => {
    const entityFilterData = entity?.value || '';
    const yearFilterData = year?.value || '';
    const monthFilterData = month?.map(m => m?.value) || [];
    const response = await axios.post(`${API_BASE_URL}/api/timelinesstask-drilldown`,
      {
        entity: entityFilterData,
        year: yearFilterData,
        month: monthFilterData,
        limit: totalRecords,
        offset: 0,
      },
      {
        headers: {
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      }
    );

    const allData = response.data.data || [];
    const csvHeader = columns.map(col => col.header).join(',');
    const csvRows = allData.map(row =>
      columns.map(col => `"${(row[col.accessor] || '').toString().replace(/"/g, '""')}"`).join(','));
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Timeliness_of_Task.csv';
    link.click();
  };

  const handleReset = () => {
    setEntity(null);
    setYear(null);
    setMonth([]);
    setWeek(WeekOptions[0]);
    setFilters({
      entityData: null,
      yearData: null,
      monthData: [],
      weekData: null,
    });
  };

  const columns = [
    { header: "Category of Task", accessor: "category_of_task" },
    { header: "No of Tasks", accessor: "number_of_tasks" },
    { header: "Remarks", accessor: "remarks" }
  ];


  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/R2R-entity`, {
        headers: {
          Authorization: "Basic YWRtaW4xOjEyMw=="
        },
      });

      const allEntities = response.data?.[0]?.all || [];
      const jlrEntities = response.data?.[0]?.jlr || [];

      const entities = Array.isArray(roles?.entity) ? roles.entity : [roles?.entity];
      const userEntities = (entities.filter(Boolean)).map((e) => e.toUpperCase());

      let entityOptionsJLR = [];

      if (userEntities.includes("JLR") && userEntities.length > 1) {
        entityOptionsJLR = [...new Set([...jlrEntities, ...allEntities])];
      } else if (userEntities.includes("JLR")) {
        entityOptionsJLR = jlrEntities;
      } else {
        entityOptionsJLR = allEntities;
      }

      setEntityOptions(entityOptionsJLR);
    } catch (error) {
      console.error("Error fetching R2R-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/R2R-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching R2R-year options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/R2R-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setMonthOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching R2R-month options:', error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    fetchMonthOptions();
  }, []);

  useEffect(() => {
    if (entityOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.entityData?.value) {
        const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        if (ent) setEntity(ent);
      }

      if (filters.yearData?.value) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter(opt =>
          filters.monthData.some(m => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.entityData?.value) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const [dataLoading, setdataLoading] = useState(false);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                styles={customStyles}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          {/* <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Week</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={week}
                onChange={setWeek}
                options={WeekOptions}
                isSearchable={true}
              />
            </div>
          </div> */}
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div>
        <div className="row" >
        </div>
        {/*First Table  */}
        <div className="row" >
          <div className="col-md-12">
            <DomainTile title='TimeLiness of Tasks' showBackButton={true} mainPagePath="/Record-To-Report/JLR" detailState={filters} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              {/* <h2> tabel here</h2> */}
              <ReusableTable
                data={data}
                columns={columns}
                itemsPerPage={itemsPerPage}
                onPageChange={handleTimelinessTaskPageChange}
                isCustomOpen={true}
                totalRecords={totalRecords}
                handleCSVDownload={handleCSVDownload}
                dataLoading={dataLoading}
              />
            </DashboardSection>
          </div>
        </div>
      </div>
    </>
  );
};

export default TimeLinessJLR;
